import { createReducer, on } from '@ngrx/store';
import {
  STORE_ARGENTINA_FIND_SUCCESS,
  STORE_ARGENTINA_FAILURE,
  STORE_ARGENTINA_UPDATE_LOADING
} from '../actions';
import {
  StoreArgentina,
} from '@core/models';

export interface StoreArgentinaState {
  loading: boolean;
  storeArgentina: StoreArgentina | null;
  error: string | null;
}

export const initialState: StoreArgentinaState = {
  loading: false,
  storeArgentina: null,
  error: null,
};

export const storeArgentinaReducer = createReducer(
  initialState,
  on(STORE_ARGENTINA_FAILURE, (storeArgentina, { error }) => ({ ...storeArgentina, error })),
  on(STORE_ARGENTINA_UPDATE_LOADING, (storeArgentina, { loading }) => ({ ...storeArgentina, loading })),
  on(STORE_ARGENTINA_FIND_SUCCESS, (storeArgentinaState, { storeArgentina }) => ({ ...storeArgentinaState,  storeArgentina })),
);
